import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_TYPE, AmmunitionStockEvent, BusinessUnit, COST_CENTRE_TYPE_WILDLIFE } from 'assets-model';
import { AmmunitionStockEventService, AmmunitionStockService, BusinessUnitService, CostCentreService } from 'assets-service';
import { AmmunitionStockItemComponentBase } from './ammunition-stock-item.component.base';


@Component({
  selector: 'app-ammunition-stock-item',
  templateUrl: './ammunition-stock-item.component.html',
  styleUrls: ['./ammunition-stock-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AmmunitionStockItemComponent extends AmmunitionStockItemComponentBase {

  ammunitionStockEvents: AmmunitionStockEvent[] = [];

  stocktakePrompted: boolean = false;

  constructor(protected ammunitionStockService: AmmunitionStockService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected ammunitionStockEventService: AmmunitionStockEventService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(ammunitionStockService, businessUnitService, costCentreService, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.costCentreLoadSelectionList();
  }

  itemSet() {
    super.itemSet();
    this.findEventsSinceLatestStocktake();
    this.addAllWarnings();
    if (!this.createMode && !this.item.hasStocktake && !this.stocktakePrompted) {
      this.openSimpleConfirmationDialog("This Ammunition Stock doesn't have an initial stocktake. Would you like to perform one now?", "Missing Stocktake", "Leave and Perform Stocktake", "Ignore").afterClosed().subscribe(result => {
        if (result) {
          this.navigateToStocktake();
        }
      });
    }
    this.stocktakePrompted = true;
  }

  setDefaultDisabledFields(): void {
    super.setDefaultDisabledFields();
    if (!this.createMode) {
      this.businessUnit?.disable();
      this.costCentre?.disable();
    }

    this.createdDate?.disable();
    this.createdBy?.disable();
    this.updatedDate?.disable();
    this.updatedBy?.disable();
  }

  addAllWarnings(): void {
    super.addAllWarnings();
    const self = this;
    this.addWarning("No Stocktake has been taken yet for this Ammunition Stock. Click the Stocktake button below to set an initial quantity.", () => !self.createMode && !self.item?.hasStocktake);
  }

  findEventsSinceLatestStocktake() {
    if (this.item.ammunitionStockId != null) {
      this.ammunitionStockEventService.findEventsSinceLatestStocktake(this.item.ammunitionStockId).subscribe(
        data => {
          this.ammunitionStockEvents = data.items;
          if (this.ammunitionStockEvents.length > 0) {
            this.item.setHasStocktake(true);
          }
        }
      );
    } else {
      this.ammunitionStockEvents = [];
    }
  }

  costCentreLoadSelectionList() {
    if (this.item.businessUnit != null) {
      this.costCentreService.findByBusinessUnitForType(this.item.businessUnit?.buId, COST_CENTRE_TYPE_WILDLIFE).subscribe(
        data => {
          this.costCentreSelectionList = data.items;
          if (this.createMode) {
            this.costCentre?.enable();
          }
        }
      );
    } else {
      this.costCentreSelectionList = [];
      this.costCentre?.disable();
    }
  }

  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    super.businessUnitChanged(value, unsetDependents);
    if (value == null || value?.buId != this.item.costCentre?.businessUnit?.buId) {
      this.item.costCentre = null;
    }
    this.costCentreLoadSelectionList();
  }

  getNavigationQueryParams() {
    return {
      businessUnitId: this.item.businessUnit?.buId,
      costCentreId: this.item.costCentre?.ccId,
      ammunitionStockId: this.item.ammunitionStockId
    };
  }

  navigateToStocktake() {
    this.router.navigate([...AMMUNITION_STOCK_TYPE.stocktakeRouteBase], {
      queryParams: this.getNavigationQueryParams()
    })
  }

  navigateToIssue() {
    this.router.navigate([...AMMUNITION_STOCK_TYPE.issueRouteBase], {
      queryParams: this.getNavigationQueryParams()
    })
  }

  navigateToAddition() {
    this.router.navigate([...AMMUNITION_STOCK_TYPE.additionsRouteBase], {
      queryParams: this.getNavigationQueryParams()
    })
  }

  navigateToReturn() {
    this.router.navigate([...AMMUNITION_STOCK_TYPE.returnRouteBase], {
      queryParams: this.getNavigationQueryParams()
    })
  }
}



